<template>
  <div>
    <SiteDetailSettingsAutobackup></SiteDetailSettingsAutobackup>
    <SiteDetailSettingsBackendlink></SiteDetailSettingsBackendlink>
    <SiteDetailSettingsMonitoring></SiteDetailSettingsMonitoring>
    <SiteDetailSettingsReport></SiteDetailSettingsReport>
  </div>
</template>

<script>
import SiteDetailSettingsAutobackup from './SiteDetailSettingsAutobackup'
import SiteDetailSettingsReport from './SiteDetailSettingsReport'
import SiteDetailSettingsBackendlink from './SiteDetailSettingsBackendlink'
import SiteDetailSettingsMonitoring from './SiteDetailSettingsMonitoring'

export default {
  name: 'SiteDetailSettings',
  components: {
    SiteDetailSettingsAutobackup,
    SiteDetailSettingsReport,
    SiteDetailSettingsBackendlink,
    SiteDetailSettingsMonitoring
  }
}
</script>
